import { clsx } from 'clsx';

export const cn = clsx;
